<template>
  <div class="container">
    <div class="row justify-content-center mb-30">
      <span class="soha-forget-pass-title">
        {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
      </span>
    </div>
    <div class="row justify-content-center mb-10" v-if="step === 1">
      <h5>
        {{ $t(`${I18nPrefix}SEND_SMS_TEXT_PART_ONE`) }}
        <span class="font-weight-bolder px-1">
          {{ toPersianDigits(username.value) }}
        </span>
        {{ $t(`${I18nPrefix}SEND_SMS_TEXT_PART_TWO`) }}
      </h5>
    </div>
    <div class="row justify-content-center">
      <soha-text-field
        v-if="step === 0"
        class="w-400px"
        @onEnterPressed="forgetPassword()"
        name="username"
        v-model.trim="username.value"
        :error="username.error"
        :placeholder="$t(`${I18nPrefix}USERNAME_PLACEHOLDER`)"
      />
      <soha-text-field
        v-else
        class="w-400px"
        @onEnterPressed="verifyCode()"
        name="code"
        v-model.trim="code.value"
        :error="code.error"
        :placeholder="$t(`${I18nPrefix}CODE`)"
      />
    </div>
    <div class="row m-0">
      <div class="w-400px mx-auto">
        <div
          :class="[
            'row mt-10 mx-0',
            step === 1 ? 'justify-content-between' : 'justify-content-end',
          ]"
        >
          <soha-button
            v-if="step === 1"
            name="continue"
            @click="verifyCode()"
            :loading="verifyCodeBtnLoading"
            width="185"
            :text="$t(`${I18nPrefix}CONTINUE`)"
            class="mb-3"
          />
          <soha-button
            name="forgetPassword"
            :disable="!!timer"
            @click="forgetPassword()"
            :loading="btnLoading"
            :text="buttonText"
            class="mb-3"
            :class="{ 'w-100': step != 1 }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import ValidationMixin from "@/mixins/ValidationMixin";
import ApiService from "@/core/services/api.service";

export default {
  mixins: [UIMixin, ValidationMixin],

  name: "ForgetPassword",

  data() {
    return {
      I18nPrefix: "JOB_SEEKER.PAGES.AUTH.FORGET_PASSWORD.",
      step: 0,
      username: {
        value: null,
        error: null,
      },
      code: {
        value: null,
        error: null,
      },
      btnLoading: false,
      resendBtn: false,
      verifyCodeBtnLoading: false,
      timer: null,
      timeRemaining: null,
    };
  },

  mounted() {
    if (this.$route.params.mobile)
      this.username.value = this.$route.params.mobile;
  },

  methods: {
    forgetPassword() {
      this.username.error = this.validateUsername(this.username.value);
      if (this.username.error) return;
      this.btnLoading = true;
      ApiService.post("api/v2/jobseeker/forget-password", {
        username: this.username.value,
      })
        .then((data) => {
          if (data.data.code == 200) {
            this.successToast(data.data.message);
            this.step = 1;
            this.startTimer(120);
            this.resendBtn = true;
          } else {
            this.errorToast(data.data.message);
          }
          this.btnLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorToast(
              this.$t(`${this.I18nPrefix}RESTART_RESET_PASSWORD_ERROR`)
            );
          } else {
            this.errorToast(this.$t(`${this.I18nPrefix}SERVER_ERROR`));
          }
          this.verifyCodeBtnLoading = false;
        });
    },

    verifyCode() {
      this.code.error = this.validateField(
        this.code.value,
        this.$t(`${this.I18nPrefix}CODE`)
      );
      if (this.code.error) return;
      this.verifyCodeBtnLoading = true;
      ApiService.post("api/v2/jobseeker/verify-code", {
        username: this.username.value,
        code: this.code.value,
      })
        .then((data) => {
          if (data.data.code == 111) {
            this.$router.push({
              name: "jobseeker-reset-password",
              params: { username: this.username.value, code: this.code.value },
            });
          } else {
            this.errorToast(data.data.message);
          }
          this.verifyCodeBtnLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorToast(
              this.$t(`${this.I18nPrefix}RESTART_RESET_PASSWORD_ERROR`)
            );
          } else {
            this.errorToast(this.$t(`${this.I18nPrefix}SERVER_ERROR`));
          }
          this.verifyCodeBtnLoading = false;
        });
    },

    startTimer(duration) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.timeRemaining = duration;
      this.timer = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
  },

  computed: {
    buttonText() {
      return this.resendBtn
        ? (this.timer ? this.resendTime + " تا " : "") +
            this.$t(`${this.I18nPrefix}RESEND`)
        : this.$t(`${this.I18nPrefix}SEND`);
    },

    resendTime() {
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      return `${0}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
  },
};
</script>

<style scoped>
.soha-forget-pass-title {
  font-size: 2.231rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.59;
  letter-spacing: normal;
  text-align: center;
  color: var(--primary-color);
}
</style>
